import { useEffect, useState } from "react";
import {
  getTrades,
  placeTrade as apiPlaceTrade,
  closeTrade as apiCloseTrade,
} from "../services/tradeService";
import useWebSocket from "./useWebSocket";

export function useTrades() {
  const [trades, setTrades] = useState<any[]>([]);
  const { registerHandler } = useWebSocket();

  const fetchTrades = async () => {
    try {
      const response = await getTrades();
      setTrades(response.data);
    } catch (error) {
      console.error("Error fetching trades:", error);
    }
  };

  const placeTrade = async (
    symbol: string,
    instrumentKey: string,
    quantity: number,
    entryPrice: number,
    target: number,
    stopLoss: number,
    side: "BUY" | "SELL"
  ) => {
    try {
      await apiPlaceTrade(
        symbol,
        instrumentKey,
        quantity,
        entryPrice,
        target,
        stopLoss,
        side
      );
      await fetchTrades(); // Refresh trades list
    } catch (error) {
      console.error("Error placing trade:", error);
    }
  };

  const closeTrade = async (tradeId: string) => {
    try {
      await apiCloseTrade(tradeId);
      await fetchTrades(); // Refresh trades list
    } catch (error) {
      console.error("Error closing trade:", error);
    }
  };

  useEffect(() => {
    fetchTrades();

    registerHandler("TRADE_PLACED", "useTrades-placed", () => {
      fetchTrades();
    });

    registerHandler("TRADE_CLOSED", "useTrades-closed", () => {
      fetchTrades();
    });
  }, [registerHandler]);

  return {
    trades,
    refreshTrades: fetchTrades,
    placeTrade,
    closeTrade,
  };
}
